import Vue from 'vue'
import VueRouter from 'vue-router'
import Requerimiento from '../components/Requerimiento.vue'
import Empleado from '../components/Empleado.vue'
import Usuario from '../components/Usuario.vue'
import Individuo from '../components/Individuo.vue'
import Monitoreo from '../components/Monitoreo.vue'
import Postulacion from '../components/Postulacion.vue'
import Login from '../components/Login.vue'
import Estandarizacion from '../components/Estandarizacion.vue'
import Empresa from '../components/Empresa.vue'
import Contratista from '../components/Contratista.vue'
import Locacion from '../components/Locacion.vue'
import Reportes from '../components/Reportes.vue'
import store from '../store'
import Postulantes from '../components/Postulantes.vue'
import PanelProveedor from '../components/PanelProveedor.vue'
import PanelContratista from '../components/PanelContratista.vue'
import Oportunidades from '../components/Oportunidades.vue'
import MisPostulaciones from '../components/MisPostulaciones.vue'
import MisRequerimientos from '../components/MisRequerimientos.vue'
import MisRequerimientosAdmin from '../components/MisRequerimientosAdmin.vue'
import FacturacionProveedor from '../components/FacturacionProveedor.vue'
import FacturacionContratista from '../components/FacturacionContratista.vue'
import CotizacionProveedor from '../components/CotizacionProveedor.vue'
import CotizacionContratista from '../components/CotizacionContratista.vue'
import Forbidden from '../components/Forbidden.vue'
import PresupuestoContratista from '../components/PresupuestoContratista'
import ReporteLocalia from '../components/ReporteLocalia'
import OportunidadesPublicas from '../components/OportunidadesPublicas.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/requerimiento',
    name: 'requerimiento',
    component: Requerimiento,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:true,
    }
  },
  {
    path: '/reportes',
    name: 'reportes',
    component: Reportes,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:false,
    }
  },
  {
    path: '/estandarizacion',
    name: 'estandarizacion',
    component: Estandarizacion,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:false,
    }
  },
  {
    path: '/locacion',
    name: 'locacion',
    component: Locacion,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:false,
    }
  },
  {
    path: '/empresa',
    name: 'empresa',
    component: Empresa,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:false,
    }
  },
  {
    path: '/contratista',
    name: 'contratista',
    component: Contratista,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:false,
    }
  },
  {
    path: '/monitoreo',
    name: 'monitoreo',
    component: Monitoreo,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:false,
    }
  },
  {
    path: '/empleado',
    name: 'empleado',
    component: Empleado,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:false,
    }
  },
   {
    path: '/usuario',
    name: 'usuario',
    component: Usuario,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:false,
    }
  },
  {
    path: '/individuo',
    name: 'individuo',
    component: Individuo,
    meta :{
      administrador :true,
      proveedor :true,
      contratista:false,
    }
  },
  {
    path: '/postulacion',
    name: 'postulacion',
    component: Postulacion,
    meta :{
      administrador :true,
      proveedor :true,
      contratista:true,
    }
  },
  {
    path: '/postulantes',
    name: 'postulantes',
    component: Postulantes,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:false,
    }
  },
  {
    path: '/panelproveedor',
    name: 'panelproveedor',
    component: PanelProveedor,
    meta :{
      administrador :true,
      proveedor :true,
      contratista:false,
    }
  },
  {
    path: '/panelcontratista',
    name: 'panelcontratista',
    component: PanelContratista,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:true,
    }
  },
  {
    path: '/oportunidades',
    name: 'oportunidades',
    component: Oportunidades,
    meta :{
      administrador :true,
      proveedor :true,
      contratista:true,
    }
  },
  {
    path: '/mispostulaciones',
    name: 'mispostulaciones',
    component: MisPostulaciones,
    meta :{
      administrador :true,
      proveedor :true,
      contratista:false,
    }
  },
  {
    path: '/misrequerimientos',
    name: 'misrequerimientos',
    component: MisRequerimientos,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:true,
    }
  },
  {
    path: '/misrequerimientosadmin',
    name: 'misrequerimientosadmin',
    component: MisRequerimientosAdmin,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:false,
    }
  },
  {
    path: '/facturacion',
    name: 'facturacion',
    component: FacturacionProveedor,
    meta :{
      administrador :true,
      proveedor :true,
      contratista:false,
    }
  },
  {
    path: '/estimacion',
    name: 'estimacion',
    component: CotizacionProveedor,
    meta :{
      administrador :true,
      proveedor :true,
      contratista:false,
    }
  },
  {
    path: '/estimacioncontrata',
    name: 'estimacioncontrata',
    component: CotizacionContratista,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:true,
    }
  },
  {
    path: '/pagos',
    name: 'pagos',
    component: FacturacionContratista,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:true,
    }
  },
  {
    path: '/presupuestocontratista',
    name: 'presupuestocontratista',
    component: PresupuestoContratista,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:false,
    }
  },
  {
    path: '/reportelocalia',
    name: 'ReporteLocalia',
    component: ReporteLocalia,
    meta :{
      administrador :true,
      proveedor :false,
      contratista:false,
    }
  },
  /*{
    path    : '/',
    redirect: '/login'
  },*/
  {
    path: '/',
    name: 'login',
    component: Login,
    meta : {
      libre: true
    }
  },
  {
    path: '/403',
    name: 'forbidden',
    component: Forbidden,
    meta: {
      libre: true
    }
  },
  {
    path: '/oportunidades-publicas',
    name: 'OportunidadesPublicas',
    component: OportunidadesPublicas,
    meta: {
      libre: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  //base: process.env.BASE_URL,
  // base:'/localmatch/',
  // base: process.env.NODE_ENV === 'production'
  //   ? '/localmatch/'
  //   : '/',
  routes
})

router.beforeEach((to, from, next) => {
  // 1️⃣ Rutas libres
  if (to.matched.some(r => r.meta.libre)) {
    return next()
  }

  let usuario = store.state.usuario

  // 2️⃣ Rehidratar desde localStorage si Vuex está vacío
  if (!usuario) {
    const guardado = localStorage.getItem('usuario')
    if (guardado) {
      try {
        usuario = JSON.parse(guardado)
        store.commit('setUsuario', usuario)
      } catch (e) {
        localStorage.removeItem('usuario')
      }
    }
  }

  // 3️⃣ Si aún no hay usuario → login
  if (!usuario) {
    return next({ name: 'login' })
  }

  const rol = usuario.rol

  // 4️⃣ Validación por rol
  const permitido =
    (rol === 'ADMINISTRADOR' && to.matched.some(r => r.meta.administrador)) ||
    (rol === 'PROVEEDOR' && to.matched.some(r => r.meta.proveedor)) ||
    (rol === 'CONTRATISTA' && to.matched.some(r => r.meta.contratista))

  if (permitido) {
    return next()
  }

  return next({ name: 'forbidden' })
})


export default router
